export default class  CashReportActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static SHOW_DATA_REPORT='SHOW_DATA_REPORT';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_CASHREPORT='GET_HELPER_CASHREPORT';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static PRINT_CASHREPORT='PRINT_CASHREPORT';
  static BEFORE_PRINT_CASHREPORT='BEFORE_PRINT_CASHREPORT';
  static submit(){
    return {
      type:  CashReportActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type:  CashReportActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type:  CashReportActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type:  CashReportActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type:  CashReportActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type:  CashReportActions.SHOW_DATA,
      payload: data
    };
  }

  static listReport(dataReport) {
    console.log("ACTION",dataReport)
    return {
      type:  CashReportActions.SHOW_DATA_REPORT,
      payload: dataReport
    };
  }
  static resetList() {
    return {
      type:  CashReportActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type:  CashReportActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type:  CashReportActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type:  CashReportActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type:  CashReportActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type:  CashReportActions.GET_HELPER_CASHREPORT,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type:  CashReportActions.ERROR_SERVER,
      payload: error
    };
  }
  static beforePrint(){
    return {
      type: CashReportActions.BEFORE_PRINT_CASHREPORT,
    };
  }
  static print(printCashReport){
    return {
      type: CashReportActions.PRINT_CASHREPORT,
      payload: printCashReport
    };
  }
}